import React, { useEffect } from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
interface ToastProps {
  message: string;
  type: 'success' | 'warning';
  isVisible: boolean;
  onClose: () => void;
}
export function Toast({
  message,
  type,
  isVisible,
  onClose
}: ToastProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);
  return <div className={`fixed bottom-6 right-6 px-5 py-3.5 rounded-xl shadow-lg text-sm font-medium flex items-center gap-2.5 transition-all duration-300 z-[200] max-w-[320px] ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'} ${type === 'success' ? 'bg-success text-white' : 'bg-warning text-white'}`} data-id="element-1165">
      {type === 'success' ? <CheckCircle size={18} data-id="element-1166" /> : <AlertCircle size={18} data-id="element-1167" />}
      {message}
    </div>;
}